import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Device from '@square/dashboard-data/models/squareup/beemo/api/v2/models/device';
export default ProtoBaseModel.extend({
  device: attr(Device)
});